/*
 * Bliss Out Coffee: make the sticky "Add to cart" bar respect subscriptions.
 *
 * Problem: the theme's sticky bar button adds only the variant and quantity
 * to the cart, never the selling plan, so a chosen subscription is added as
 * a one-time purchase.
 *
 * Fix: when a subscription is selected in the main product form, a click on
 * the sticky bar button is handed to the main "Add to cart" button, which
 * sends the selling plan. One-time purchases keep the theme's own behavior.
 *
 * If the page markup is not found, this script does nothing.
 */
(function () {
  if (window.__blissStickyPlan) return;
  window.__blissStickyPlan = true;

  window.addEventListener(
    'click',
    function (e) {
      var stickyBtn = e.target.closest('.t4s-sticky-atc [data-action-atc]');
      if (!stickyBtn) return;

      // On mobile the first tap only opens the sticky panel; let the theme do that.
      if (stickyBtn.hasAttribute('data-action-delay') && window.innerWidth <= 767) return;

      var plan = document.querySelector('form[data-type="add-to-cart-form"] input[name="selling_plan"]');
      if (!plan || !plan.value) return;

      var form = plan.closest('form');
      var mainBtn = form && form.querySelector('[data-atc-form]');
      if (!mainBtn || mainBtn.disabled) return;

      // Carry over the quantity chosen in the sticky bar.
      var stickyQty = stickyBtn.closest('.t4s-sticky-atc').querySelector('[data-quantity-value]');
      var mainQty = form.querySelector('[data-quantity-value]') ||
        document.querySelector('[data-quantity-value][form="' + form.getAttribute('id') + '"]');
      if (stickyQty && mainQty) mainQty.value = stickyQty.value;

      e.preventDefault();
      e.stopImmediatePropagation();
      mainBtn.click();
    },
    true
  );
})();
